(function () {
  'use strict';
  const names = new Set(['phone_model_selected', 'personalizer_opened', 'design_saved', 'design_save_rejected', 'personalizer_closed_without_save', 'purchase_blocked']);
  const reasons = new Set(['missing_saved_design', 'unsupported_model', 'invalid_provider_payload']);
  const fields = ['brand', 'model', 'caseStyle', 'productHandle', 'variantId'];
  function publish(name, selection) {
    if (!names.has(name)) return false;
    const shopify = window.Shopify;
    try {
      if (shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return false;
      if (typeof shopify?.analytics?.publish !== 'function') return false;
      const payload = {};
      for (const key of fields) {
        const value = String(selection?.[key] || '');
        if (value && value.length <= 100 && /^[a-z0-9 _+().-]+$/i.test(value)) payload[key] = value;
      }
      if (reasons.has(selection?.reason)) payload.reason = selection.reason;
      Promise.resolve(shopify.analytics.publish('gocraftly:' + name, payload)).catch(function () {});
      return true;
    } catch (_) {
      // Analytics must never interrupt selecting, saving, or buying a case.
      return false;
    }
  }
  window.GoCraftlyStorefrontEvents = Object.freeze({ publish: publish });
  if (typeof document !== 'undefined') {
    document.addEventListener('change', function (event) {
      const select = event.target;
      if (!(select instanceof HTMLSelectElement) || !select.matches('#modelSelect, [data-gcp-model-select], [data-gc-phone-model-select]')) return;
      const model = select.value;
      if (!model) return;
      publish('phone_model_selected', { model: model, brand: /^iphone/i.test(model) ? 'iphone' : 'samsung' });
    });
  }
})();
